module.exports = __webpack_public_path__ + "img/img_measure_c.0644e129.svg";